import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "triangle-down-icon_jax_8fbd994b63954b79ed6cabb0ae69ac4f",
  "use": "triangle-down-icon_jax_8fbd994b63954b79ed6cabb0ae69ac4f-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" id=\"triangle-down-icon_jax_8fbd994b63954b79ed6cabb0ae69ac4f\"><path d=\"M13.14 15.298a.5.5 0 0 1-.854 0L8.918 9.76A.5.5 0 0 1 9.345 9h6.737a.5.5 0 0 1 .427.76l-3.368 5.538z\" fill=\"#2A2A2A\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol